<template>
  <v-app>
    <core-toolbar />

    <core-drawer />

    <v-content id="view">
      <div id="help">
        <v-container pb-0>
          <base-subheading>Как помочь</base-subheading>
        </v-container>
        <volunteer />
        <thing />
        <requisite />
      </div>
    </v-content>

    <core-footer />
  </v-app>
</template>

<script>
  export default {
    name: 'Help',

    components: {
      CoreToolbar: () => import('@/components/core/Toolbar'),
      CoreDrawer: () => import('@/components/core/Drawer'),
      CoreFooter: () => import('@/components/core/Footer'),
      Volunteer: () => import('@/components/help/Volunteer'),
      Thing: () => import('@/components/help/Thing'),
      Requisite: () => import('@/components/help/Requisite')
    }
  }
</script>

<style>
  @import '../styles/main.css'
</style>
